import gql from 'graphql-tag';

export const INSERT_SHIPPING_PROVIDER = gql`
  mutation insertIntegration(
    $clientId: uuid!
    $providerId: uuid!
    $service: String!
    $metadata: jsonb!
    $alias: String!
  ) {
    insert_proveedor_paqueteria_cliente(
      objects: {
        id_cliente: $clientId
        id_proveedor: $providerId
        servicio_acargo: $service
        metadata: $metadata
        alias: $alias
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_SHIPPING_PROVIDER = gql`
  mutation deleteShippingProvider($pk: uuid!) {
    delete_proveedor_paqueteria_cliente(where: { id: { _eq: $pk } }) {
      affected_rows
    }
  }
`;

export const INSERT_ECOMMERCE_PROVIDER = gql`
  mutation insertECommerceProvider(
    $alias: String!
    $apiKey: String!
    $domain: String!
    $secretKey: String!
    $webhookKey: String!
    $integratorId: uuid!
    $clientId: uuid!
  ) {
    insert_tienda_cliente(
      objects: {
        alias: $alias
        api_key: $apiKey
        dominio: $domain
        id_cliente: $clientId
        id_integrador: $integratorId
        secret_key: $secretKey
        webhook_key: $webhookKey
      }
    ) {
      affected_rows
      __typename
    }
  }
`;

export const DELETE_ECOMMERCE_PROVIDER = gql`
  mutation deleteECommerce($pk: uuid!) {
    delete_tienda_cliente(where: { id_tienda: { _eq: $pk } }) {
      affected_rows
    }
  }
`;

export const GENERATE_API_KEY = gql`
  mutation generateApiKey($name: String!, $clientId: uuid) {
    generateApiKey(nombre: $name, idClient: $clientId) {
      apiKey
    }
  }
`;

export const DELETE_API_KEY = gql`
  mutation deleteApiKey($clientId: uuid!) {
    delete_llave_api(where: { id_cliente: { _eq: $clientId } }) {
      affected_rows
    }
  }
`;

export const UPDATE_WEBHOOK = gql`
  mutation updateWebhook(
    $clientId: uuid!
    $webhookSecret: String!
    $webhookUrl: String!
  ) {
    update_configuracion_cuenta(
      where: { id_cliente: { _eq: $clientId } }
      _set: { web_hook_secret: $webhookSecret, web_hook_url: $webhookUrl }
    ) {
      affected_rows
    }
  }
`;
